module.exports = __webpack_public_path__ + "static/media/peeled_tomatoes_glass.610b6a6f.png";